import { render, staticRenderFns } from "./ConfirmStep.vue?vue&type=template&id=0ec60411&scoped=true&"
import script from "./ConfirmStep.vue?vue&type=script&lang=js&"
export * from "./ConfirmStep.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmStep.vue?vue&type=style&index=0&id=0ec60411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec60411",
  null
  
)

export default component.exports